<template>
  <div>
    <div v-if="isLoginLP">
      <AppForm
        v-if="userBelongType === 'agency' && mode !== modes.READONLY"
        label="広告主名"
        class="form-row-height"
      >
        <v-layout>
          <v-radio-group v-model="useAdvertiser" row>
            <v-radio :value="false" label="広告主を選択しない" />
            <v-radio :value="true" label="広告主を選択する" />
          </v-radio-group>
        </v-layout>
      </AppForm>
      <AppForm
        v-if="userBelongType !== 'agency' && mode !== modes.READONLY"
        label="代理店名・広告主名"
        class="form-row-height"
      >
        <v-layout>
          <v-radio-group v-model="useAdvertiser" row>
            <v-radio :value="false" label="代理店を選択する" />
            <v-radio :value="true" label="広告主を選択する" />
          </v-radio-group>
        </v-layout>
      </AppForm>
      <AppForm v-show="useAdvertiser" label="" class="form-row-height">
        <v-autocomplete
          v-if="selectedAdvertiser === undefined && mode !== modes.READONLY"
          v-model="selectedAdvertiser"
          :items="advertiserList"
          :search-input.sync="searchAdvertiserWord"
          :loading="isLoadingAdvertiserList"
          item-text="name"
          placeholder="広告主名を入力してください"
          no-data-text="No data"
          append-icon="search"
          autofocus
          outlined
          dense
          clearable
          return-object
        />
        <div v-if="selectedAdvertiser" style="font-size: 1.3rem">
          {{ selectedAdvertiser.name }}
          <v-btn @click="selectedAdvertiser = undefined" small icon>
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
      </AppForm>
      <AppForm
        v-if="
          isLoginLP &&
            userBelongType === 'system owner' &&
            useAdvertiser === false
        "
        class="form-row-height"
      >
        <v-autocomplete
          v-if="selectedAgency === undefined && !form.basicSetting.isReadOnly"
          v-model="selectedAgency"
          :items="agencyList"
          :search-input.sync="searchAgencyWord"
          :loading="isLoadingAgencyList"
          item-text="name"
          placeholder="代理店名を入力してください"
          no-data-text="No data"
          append-icon="search"
          autofocus
          outlined
          dense
          clearable
          return-object
        />
        <div v-if="selectedAgency" style="font-size: 1.3rem">
          {{ selectedAgency.name }}
          <v-btn @click="selectedAgency = undefined" small icon>
            <v-icon>edit</v-icon>
          </v-btn>
        </div>
      </AppForm>
    </div>
    <AppForm label="シミュレーション名">
      <v-layout v-if="mode !== modes.READONLY">
        <v-text-field v-model="form.basicSetting.name" hide-details />
      </v-layout>
      <v-layout v-if="mode === modes.READONLY">
        <span>{{ form.basicSetting.name }}</span>
      </v-layout>
    </AppForm>
    <AppForm label="配信日数">
      <v-layout>
        <v-flex v-if="mode !== modes.READONLY" xs2>
          <v-text-field
            v-model.number="form.basicSetting.deliveryDays"
            :min="minDeliveryDays"
            type="number"
            class="text-xs-right"
            hide-details
          />
        </v-flex>
        <v-flex v-if="mode !== modes.READONLY" class="unit" xs10>日</v-flex>
        <v-layout v-if="mode === modes.READONLY">
          <span>{{ form.basicSetting.deliveryDays }}</span>
        </v-layout>
      </v-layout>
    </AppForm>
    <AppForm label="クリエイティブ種別">
      <v-radio-group
        ref="creativeType"
        v-if="mode !== modes.READONLY"
        v-model="creativeType"
        class="creative-types"
        row
      >
        <v-layout wrap>
          <v-flex
            v-for="(item, index) in creativeTypes"
            :key="index"
            style="width: 200px;"
          >
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <img
                  v-on="on"
                  @click="creativeIconClick(item)"
                  :src="item.iconImage"
                  :class="{
                    'creative-icon': true,
                    'creative-choice': item.value === creativeType,
                  }"
                  alt=""
                />
              </template>
              <div class="creative-icon-tooltip">
                <img :src="item.sampleImage" alt="" />
              </div>
              <div class="creative-sample-message">
                <h3 v-html="item.text" />
                <span v-html="item.sampleMessage" />
              </div>
            </v-tooltip>
            <v-radio
              :label="item.text"
              :value="item.value"
              class="creative-radio"
            />
          </v-flex>
        </v-layout>
      </v-radio-group>
      <v-layout v-if="mode === modes.READONLY">
        <v-flex align-self-bottom>
          <span class="text-no-wrap">
            {{
              getCreativeTypeText(
                form.basicSetting.ownerProfileMenu.creativeType,
              )
            }}
          </span>
        </v-flex>
      </v-layout>
    </AppForm>
    <div v-if="creativeType !== undefined">
      <AppForm
        v-if="creativeType === 'banner'"
        label="バナーサイズ"
        class="form-row-height"
      >
        <v-layout v-if="mode !== modes.READONLY" row wrap>
          <v-checkbox
            v-for="(item, index) in BannerSizeItems"
            :key="index"
            :input-value="form.basicSetting.creativeSetting.hasCode(item.code)"
            @click.native="onChange(item.code, $event)"
            :false-value="false"
            :label="item.text"
            :readonly="true"
          />
        </v-layout>
        <v-layout v-if="mode === modes.READONLY">
          <v-flex align-self-bottom>
            <span
              v-bind:key="index"
              v-for="(bannerCodeName, index) in form.basicSetting
                .creativeSetting.bannerCodeNames"
              class="text-no-wrap"
            >
              {{ bannerCodeName }}
              <span
                v-if="
                  index !==
                    form.basicSetting.creativeSetting.bannerCodeNames.length - 1
                "
              >
                ,
              </span>
            </span>
          </v-flex>
        </v-layout>
      </AppForm>
      <AppForm label="配信メニュー" />

      <AppForm
        v-if="mode === modes.READONLY && userBelongType !== 'advertiser'"
        label="代理店マージン"
      >
        <v-layout>
          <span>{{ form.basicSetting.ownerProfileMenu.agencyMargin }}%</span>
        </v-layout>
      </AppForm>
      <div
        v-if="
          mode !== modes.READONLY &&
            userBelongType !== 'advertiser' &&
            (selectedAdvertiser !== undefined || selectedAgency !== undefined)
        "
        class="agency-margin-container"
      >
        代理店マージンを選択してください

        <v-select
          :items="agencyMarginList"
          v-model="selectedAgencyMargin"
          item-text="text"
          item-value="value"
          class="agency-margin-select"
        />
      </div>

      <v-layout v-if="mode !== modes.READONLY">
        <MenuSection
          @onChangeMenu="onChangeMenu"
          :ownerProfileMenuId="form.basicSetting.ownerProfileMenu.id"
          :menuList="filteredMenuList"
          :editMode="false"
          :loading="menuLoading"
        />
      </v-layout>
      <v-layout v-if="mode === modes.READONLY">
        <MenuSectionConfirm
          :grossPrice="form.basicSetting.ownerProfileMenu.grossPrice"
          :unitType="form.basicSetting.ownerProfileMenu.unitType"
          :name="form.basicSetting.ownerProfileMenu.menuName"
        />
      </v-layout>
    </div>
  </div>
</template>

<script>
import MenuSection from '@/components/Shared/Common/SimulationFormMenu.vue'
import MenuSectionConfirm from '@/components/Shared/Simulation/SimulationContentBasicMenuConfirm.vue'
import { mapGetters } from 'vuex'
import { MenuModel } from '@/models/Menu'
import { modes } from '@/vuex/modules/simulation/constants'
import { CreativeTypes } from '@/models/Creative'
import { BannerSizes } from '@/models/Simulation/Constants'
import { SimulationFormBasic } from '@/models/Simulation'
import AgencyApi from '@/api/agency'
import AdvertiserApi from '@/api/AdvertiserApi'
import debounce from 'lodash/debounce'
import bannerIcon from '@/assets/images/creative/banner-icon.png'
import inFeedIcon from '@/assets/images/creative/in-feed-icon.png'
import bannerSample from '@/assets/images/creative/banner-sample.png'
import inFeedSample from '@/assets/images/creative/in-feed-sample.png'

const CreativeTypeItems = [
  {
    value: CreativeTypes.INFEED,
    text: 'インフィード',
    iconImage: inFeedIcon,
    sampleImage: inFeedSample,
    sampleMessage:
      'アプリのコンテンツと<br/>コンテンツの間に<br/>出現する記事風の広告',
  },
  {
    value: CreativeTypes.BANNER,
    text: 'バナー（静止画）',
    iconImage: bannerIcon,
    sampleImage: bannerSample,
    sampleMessage: '通常の静止画',
  },
]
export default {
  name: 'SimulationModelContentBasic',
  components: {
    MenuSection,
    MenuSectionConfirm,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searchWord: '',
      BannerSizeItems: [
        { code: BannerSizes._320x50, text: '320 x 50' },
        { code: BannerSizes._300x250, text: '300 x 250' },
      ],
      CreativeTypeItems,
      menuLoading: false,
      searchAgencyWord: '',
      searchAdvertiserWord: '',
      advertiserList: [],
      agencyList: [],
      agencyMarginList: [],
      isLoadingAgencyList: false,
      isLoadingAdvertiserList: false,
    }
  },
  computed: {
    creativeTypes() {
      return CreativeTypeItems
    },
    creativeType: {
      get() {
        return this.form.basicSetting.ownerProfileMenu.creativeType
      },
      set(creativeType) {
        this.form.basicSetting.setCreativeType(creativeType)
      },
    },
    filteredMenuList() {
      return this.form.basicSetting.menus.filter(
        menu => menu.creativeType === this.creativeType,
      )
    },
    ...mapGetters('simulation', ['mode']),
    minDeliveryDays() {
      return SimulationFormBasic.MIN_DELIVERY_DAYS
    },
    modes() {
      return modes
    },
    isLoginLP() {
      return this.$route.name.includes('LoginLp')
    },
    isReadOnly() {
      return this.$route.name.includes('readonly')
    },
    creativeSetting() {
      return this.form.basicSetting.creativeSetting
    },
    useAdvertiser: {
      set(useAdvertiser) {
        if (!useAdvertiser) {
          this.form.basicSetting.resetAdvertiser()
        }
        this.form.basicSetting.useAdvertiser = useAdvertiser
      },
      get() {
        return this.form.basicSetting.useAdvertiser
      },
    },
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userBelongName() {
      return this.$store.getters['account/belongName']
    },
    selectedAgency: {
      set(agency) {
        this.form.basicSetting.selectedAgency = agency
      },
      get() {
        return this.form.basicSetting.selectedAgency
      },
    },
    selectedAdvertiser: {
      set(advertiser) {
        this.form.basicSetting.selectedAdvertiser = advertiser
      },
      get() {
        return this.form.basicSetting.selectedAdvertiser
      },
    },
    selectedAgencyMargin: {
      set(agencyMargin) {
        this.form.basicSetting.ownerProfileMenu.agencyMargin = agencyMargin
      },
      get() {
        return this.form.basicSetting.ownerProfileMenu.agencyMargin
      },
    },
  },
  watch: {
    /**
     * 以下のいずれかの値に変更があったとき、メニューを取得しなおす
     *   selectedAgency: 選択されたtagency
     *   selectedAgencyMargin: 選択されたagencyMargin
     *   selectedAdvertiser: 選択されたadvsertiser
     */
    async selectedAgency() {
      if (this.selectedAgency === undefined) {
        this.form.basicSetting.agencyId = undefined
        this.form.basicSetting.menus = []
        return
      }

      this.form.basicSetting.agencyId =
        this.userBelongType === 'system owner'
          ? this.selectedAgency.id
          : undefined

      // menu取得
      this.menuLoading = true
      const menus = await this.fetchMenus()
      this.form.basicSetting.menus = menus
      this.menuLoading = false

      // margin取得
      this.agencyMarginList = await this.fetchAgencyMarginList(
        this.selectedAgency.id,
      )

      // デフォルト値設定
      if (this.selectedAgencyMargin === undefined) {
        this.selectedAgencyMargin = this.agencyMarginList.find(
          margin => margin.isDefault,
        ).value
      }
    },
    async selectedAgencyMargin() {
      this.menuLoading = true
      const menus = await this.fetchMenus()
      this.form.basicSetting.menus = menus
      if (menus.length === 0) {
        // agencyMarginを選んだ時、メニューがない場合はアラートを出す
        await this.$confirm(
          `取得できるメニューがありません。別の代理店マージンを選択するか、システム管理者にお問い合わせください。`,
          {
            onlyOk: true,
            okText: '閉じる',
          },
        )
      }
      this.menuLoading = false
    },
    async selectedAdvertiser() {
      if (this.selectedAdvertiser === undefined) {
        this.form.basicSetting.menus = []
        return
      }
      this.menuLoading = true
      const menus = await this.fetchMenus()
      this.form.basicSetting.menus = menus
      this.menuLoading = false

      // advertiserの場合はmarginを取得しない
      if (this.userBelongType === 'advertiser') return
      this.agencyMarginList = await this.fetchAgencyMarginList(
        this.selectedAdvertiser.agencyId,
      )
      // 選択されていない場合は、defaultのものを選択する
      if (this.selectedAgencyMargin === undefined) {
        this.selectedAgencyMargin = this.agencyMarginList.find(
          margin => margin.isDefault,
        ).value
      }
    },
    searchAgencyWord: debounce(function() {
      this.searchAgency()
    }, 1000),
    searchAdvertiserWord: debounce(function() {
      this.searchAdvertiser()
    }, 1000),
    async useAdvertiser() {
      if (!this.isLoginLP) return
      if (this.useAdvertiser) {
        this.selectedAgency = undefined
      } else {
        this.selectedAdvertiser = undefined
        if (this.userBelongType === 'agency') {
          // agency所属の場合は代理店を自動で選んであげる
          const ret = await AgencyApi.get(this.userBelongId)
          this.selectedAgency = ret.item
        }
      }
    },
  },
  async created() {
    await this.$store.dispatch('account/GET')
    /**
     * simulation共有ページの場合
     */
    if (this.mode === modes.READONLY) {
      // なにもしない
      return
    }

    /**
     * loginLpの場合
     */
    if (this.isLoginLP) {
      // advertiser所属のsimulationの場合は、advを選択する
      if (this.form.basicSetting.advertiserId !== undefined) {
        const advertiser = await AdvertiserApi.fetchAdvertiser(
          this.form.basicSetting.advertiserId,
        )
        this.selectedAdvertiser = advertiser.item
        return
      }

      // advertiserに所属していないsimulationの場合
      // Agencyが選ばれている
      if (this.selectedAgency) {
        // agencyを選択
        const agency = this.selectedAgency
        this.selectedAgency = undefined
        this.selectedAgency = agency
      }
      // AdvertiserもAgencyも選ばれていない場合
      else {
        const agencyId = this.form.basicSetting.agencyId
          ? this.form.basicSetting.agencyId
          : this.userBelongType === 'agency'
          ? this.userBelongId
          : undefined
        if (agencyId !== undefined) {
          const ret = await AgencyApi.get(agencyId)
          this.selectedAgency = ret.item
        }
      }
      return
    }

    /**
     * 広告主画面の場合
     */
    if (this.userBelongType === 'advertiser') {
      // 広告主所属ユーザー
      if (this.form.basicSetting.advertiserId !== undefined) {
        if (this.form.basicSetting.advertiserId !== this.userBelongId) {
          // 広告主所属ユーザーと共有されたシミュレーションのadvが異なる場合、
          // 所属している広告主を選択する
          const ret = await AdvertiserApi.fetchAdvertiser(this.userBelongId)
          this.selectedAdvertiser = ret.item
          return
        }
        const ret = await AdvertiserApi.fetchAdvertiser(
          this.form.basicSetting.advertiserId,
        )
        this.selectedAdvertiser = ret.item
        return
      }
      // ここにはこない
      return
    }

    // 代理店以上所属ユーザー
    if (
      this.userBelongType === 'agency' ||
      this.userBelongType === 'system owner'
    ) {
      // A. adv simulationの場合
      if (this.form.basicSetting.advertiserId !== undefined) {
        // advertiserだけ選択
        const ret = await AdvertiserApi.fetchAdvertiser(
          this.form.basicSetting.advertiserId,
        )
        this.selectedAdvertiser = ret.item
        return
      }
      // ここにはこない
      return
    }
  },
  methods: {
    /**
     * menuをもってくるlogicはすべてここに
     */
    async fetchMenus() {
      const filterMenu = menus => menus.filter(MenuModel.isGeoTargeting)
      const menus = await (async () => {
        if (this.userBelongType === 'advertiser') {
          if (this.selectedAdvertiser) {
            const searchResult = await MenuModel.searchForSimulationPlanFromAdvBelongUser(
              this.selectedAdvertiser.id,
            )
            return filterMenu(searchResult.items)
          }
        }
        if (
          this.selectedAdvertiser !== undefined &&
          this.selectedAgencyMargin !== undefined
        ) {
          const menus = await (async () => {
            const searchResult = await MenuModel.searchForSimulationPlanByAdvertiserId(
              this.selectedAdvertiser.id,
              this.selectedAgencyMargin,
            )
            return filterMenu(searchResult.items)
          })()
          return menus
        }
        if (
          this.selectedAgency !== undefined &&
          this.selectedAgencyMargin !== undefined
        ) {
          const menus = await (async () => {
            const searchResult = await MenuModel.searchForSimulationPlanByAgencyId(
              this.selectedAgency.id,
              this.selectedAgencyMargin,
            )
            return filterMenu(searchResult.items)
          })()
          return menus
        }
        return []
      })()
      return menus
    },
    async fetchAgencyMarginList(agencyId) {
      const agencyMargins = await AgencyApi.getAgencyMargins(agencyId)

      return [
        agencyMargins.items.find(margin => margin.isDefault),
        ...agencyMargins.items.filter(margin => !margin.isDefault),
      ].map(margin => ({
        text: `${margin.marginValue}%${
          margin.isDefault ? '（デフォルト）' : ''
        }`,
        value: margin.marginValue,
        isDefault: margin.isDefault !== undefined ? margin.isDefault : false,
      }))
    },
    async searchAgency() {
      if (this.searchAgencyWord !== null && this.searchAgencyWord !== '') {
        this.isLoadingAgencyList = true
        const res = await AgencyApi.searchAgency({
          keyword: this.searchAgencyWord,
          minPermissionLevel: 'view',
        })
        this.agencyList = res.items
        if (this.userBelongType === 'agency') {
          this.selectedAgency = this.agencyList.find(
            agency => agency.id === this.userBelongId,
          )
        }
        this.isLoadingAgencyList = false
      }
    },
    async searchAdvertiser() {
      if (
        this.searchAdvertiserWord !== null &&
        this.searchAdvertiserWord !== ''
      ) {
        this.isLoadingAdvertiserList = true
        const res = await AdvertiserApi.searchAdvertiser({
          keyword: this.searchAdvertiserWord,
          minPermissionLevel: 'view',
        })
        this.advertiserList = res.items
        this.isLoadingAdvertiserList = false
      }
    },
    creativeIconClick(item) {
      this.creativeType = item.value
    },
    onChange(code) {
      const hasCode = this.creativeSetting.hasCode(code)
      if (hasCode && this.creativeSetting.isOnlyOneBanner) {
        this.$confirm('バナーサイズは必ず1つ選択してください', {
          onlyOk: true,
          okText: '閉じる',
        })
        return
      }
      this.toggleBannerSize(code)
    },
    toggleBannerSize(code) {
      if (!this.creativeSetting.hasCode(code)) {
        this.creativeSetting.addCode(code)
        return
      }
      this.creativeSetting.removeCode(code)
    },
    onChangeMenu(menuId, creativeType) {
      this.form.basicSetting.ownerProfileMenu.id = menuId
      this.form.basicSetting.setCreativeType(creativeType)
    },
    getCreativeTypeText(creativeType) {
      return this.creativeTypes.find(item => item.value === creativeType).text
    },
  },
}
</script>

<style scoped>
.unit {
  padding-top: 10px;
}
.form-row-height {
  height: 30px;
}
.agency-margin-container {
  margin-top: 30px;
  margin-bottom: 30px;
}
.agency-margin-select {
  width: 100px;
}
.agency-container {
  display: flex;
  flex-direction: row;
}
readonly-data {
  padding-top: 5px;
}
.creative-icon {
  padding: 5px;
  width: 110px;
}
.creative-choice {
  background-color: #c8dbff;
}
.creative-radio {
  margin-top: 12px;
}
.creative-icon-tooltip {
  width: 180px;
}
.creative-sample-message {
  text-align: center;
  width: 180px;
}
</style>
